import store from 'shared/store'
import { RESET_SELECT_VALUES } from 'shared/store/ducks/events'
import blockUI from 'views/assets/scripts/blockUI'
import buyBoxSticky from 'views/assets/scripts/buyBoxSticky'
import eRxModal from 'views/assets/scripts/eRxModal'
import { handleVariantClick } from 'views/assets/scripts/prescriptionType'
import {
  IS_DISABLED_CLASSNAME,
  SELECT_CONTAINER,
  SELECT_ELEMENT,
  SELECT_REPLACEMENT,
} from 'views/assets/scripts/select'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import buildClientAPI from 'views/providers/clientAPI'

const CHOICES_INSTANCE_SELECTOR = '[name="prescriptionType"]'
const VARIANTS_WRAPPER_SELECTOR =
  '[data-clientside-hook="imageGallery__zoom-container"]'

export default async () => {
  const prescriptionSelects = [
    ...document.querySelectorAll(CHOICES_INSTANCE_SELECTOR),
  ]

  const {
    publicConfig: { locale = '' },
  } = store.getPublicRuntimeConfig()

  const cartContainsAnyERXEntries = async () => {
    const { cartService } = buildClientAPI()

    const {
      data: { hasERxItems },
    } = await cartService.fetchMetadata()

    return hasERxItems
  }
  let hydrated = false
  const hasERXEntries = await cartContainsAnyERXEntries()
  if (hasERXEntries) {
    const container = document.getElementById('h_ProductVariants')

    const catalogs = await loadCatalogs(locale)
    const hydrateProductVariantsComponent = await import(
      /* webpackChunkName: "ProductVariantsContainerWithHydration", webpackPrefetch: true */
      './ProductVariantsContainerWithHydration'
    )

    hydrateProductVariantsComponent.default({
      container,
      locale,
      catalogs,
    })

    buyBoxSticky()
    hydrated = true
  }

  const loadProductVariants = async event => {
    const {
      target,
      target: { value: prescriptionType },
    } = event

    const selectContainer = target.closest(SELECT_CONTAINER)
    const selectReplacement = selectContainer.querySelector(SELECT_REPLACEMENT)

    const unblockUI = blockUI({
      target: document.querySelector(VARIANTS_WRAPPER_SELECTOR),
      onShow: () => selectReplacement.classList.add(IS_DISABLED_CLASSNAME),
      onHide: () => selectReplacement.classList.remove(IS_DISABLED_CLASSNAME),
    })
    const container = document.getElementById('h_ProductVariants')

    const catalogs = await loadCatalogs(locale)
    const hydrateProductVariantsComponent = await import(
      /* webpackChunkName: "ProductVariantsContainerWithHydration", webpackPrefetch: true */
      './ProductVariantsContainerWithHydration'
    )

    hydrateProductVariantsComponent.default({
      container,
      locale,
      catalogs,
      prescriptionType,
    })

    unblockUI()
    buyBoxSticky()

    handleVariantClick(prescriptionType)

    prescriptionSelects.forEach(select => {
      select.removeEventListener('change', loadProductVariants)
    })

    store.dispatch({
      type: RESET_SELECT_VALUES,
      selects: [...container.querySelectorAll(SELECT_ELEMENT)],
    })
  }
  if (!hydrated) {
    prescriptionSelects.forEach(select => {
      select.addEventListener('change', loadProductVariants)
    })
  }
  eRxModal()
}
